// import React, {useState} from 'react';
import React, {useContext,useRef, useEffect} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
//import MenuIcon from '@material-ui/icons/Menu';
//import MoreIcon from '@material-ui/icons/MoreVert';
import LocalGroceryStoreIcon from '@material-ui/icons/LocalGroceryStore';
//import HistoryIcon from '@material-ui/icons/History';
// import MenuItem from '@material-ui/core/MenuItem';
// import Menu from '@material-ui/core/Menu';
//import LanguageSwitcher from '../../LanguageSwitcher';
//import {toggleNavCollapsed} from '../../../../redux/actions';
import {useSelector} from 'react-redux';
//import Hidden from '@material-ui/core/Hidden';
import Box from '@material-ui/core/Box';
//import SearchBar from '../../SearchBar';
import useStyles from './AppHeader.style';
import HeaderMessages from '../../HeaderMessages';
//import Notifications from '../../Notifications';
import AppLogo from '../../../../shared/components/AppLogo';
import clsx from 'clsx';
import List from '@material-ui/core/List';
import Button from '@material-ui/core/Button';
import Scrollbar from '../../Scrollbar';
import IntlMessages from '../../../utility/IntlMessages';
import {useHistory} from 'react-router-dom';
import CartTableItem from '../../../../modules/ecommerce/Carts/CartTable/CartTableItem';
import { AppState } from '../../../../redux/store';
//import { getCartItems } from '../../../../redux/actions/Ecommerce';
import { Fonts } from '../../../../shared/constants/AppEnums';
import Badge from '@material-ui/core/Badge';
import Popover from '@material-ui/core/Popover';
import HistoryMessages from '../../HistoryMessages';
import { Typography } from '@material-ui/core';
//import LocationDisplay from '../../LocationDisplay';
import {CartItems} from '../../../../types/models/ecommerce/EcommerceApp';
//import TopNotification from '@crema/core/TopNotification';
import NotificationBar from './NotificationBar';
import  AppContextPropsType from '../../../../types/AppContextPropsType';
import AppContext from '../../../utility/AppContext';

interface AppHeaderProps {}

const AppHeader: React.FC<AppHeaderProps> = () => {
  const classes = useStyles();
  const history = useHistory();
  const elementRef: any = useRef(null);

  const {cartItems} = useSelector<AppState, AppState['ecommerce']>(
    ({ecommerce}) => ecommerce,
  );

  const getCartCount = () =>{
    let cartCount:number = 0;
    for(let count=0; count< cartItems.length; count++)
    {
      cartCount = cartCount + cartItems[count].count;
    }
    return cartCount;
  }

  const [
    mobileMoreAnchorEl,
    setMobileMoreAnchorEl,
  ] = React.useState<null | HTMLElement>(null);

  function handleMobileMenuClose() {
    setMobileMoreAnchorEl(null);
  }

  function handleMobileMenuOpen(event: React.MouseEvent<HTMLElement>) {
    setMobileMoreAnchorEl(event.currentTarget);
  }

  const getThreeItems = (cartItems: CartItems[]) =>{
    return cartItems.slice(0,3);
  }

  const {setHeaderHeight} = useContext<AppContextPropsType>(AppContext);

  useEffect(() => {
    setHeaderHeight(elementRef.current.clientHeight);
  }, []); //empty dependency array so it only runs once at render

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Popover
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{vertical: 'top', horizontal: 'center'}}
      open={Boolean(mobileMoreAnchorEl)}
      onClose={handleMobileMenuClose}>
      {/* <MenuItem className={classes.menuItemRoot}>
        <HeaderMessages />
      </MenuItem>
      <MenuItem className={classes.menuItemRoot}>
        <HistoryMessages />
      </MenuItem>
      {/* <LocationDisplay /> */}
      <Box>
            <Box px={5} py={3}>
            {/* Only cart have item, then show View all and cart list */}
            {cartItems.length > 0 ? 
              <Box component='h5' fontWeight={Fonts.MEDIUM}>
                <IntlMessages id='sidebar.ecommerce.cart' />({getCartCount()})
              </Box>
               : 
               <Box component='h5' fontWeight={Fonts.MEDIUM}>Your cart is empty.</Box>
              }
            </Box>  

          {cartItems.length > 0 ? 
            <Scrollbar className='scroll-submenu'>
              <List
                className={classes.listRoot}
                onClick={() => {
                  setMobileMoreAnchorEl(null);
                }}>
               {getThreeItems(cartItems).map(data => (
                <CartTableItem data={data} key={data.ProductCode} />
                ))}
                {cartItems.length>3?
                 <Box
                  mb={2}
                  mt={2}
                  display='flex'
                  flexDirection={{xs: 'row', sm: 'row'}}
                  alignItems='center'
                  justifyContent='center'
                  > More items in cart ... 
                 </Box>
              :null}
              </List>
            </Scrollbar>
            : null }

            {cartItems.length > 0 ? 
            <Box mt={2} mb={2} justifyContent='center' display='flex'>
              <Button
                className={classes.btnPopover}
                variant='contained'
                color='primary'
                onClick={() => {
                  setMobileMoreAnchorEl(null); //hide cart details after click view all
                  history.push('/ecommerce/cart');
                }}
                >
                <Typography style={{color: '#000000'}}>
                    <IntlMessages id='common.viewAll' />
                </Typography>
              </Button>
            </Box>
            : null }
            
          </Box>
    </Popover>
  );

  return (
    <>
    <AppBar color='inherit' className={clsx(classes.appBar, 'app-bar')} ref={elementRef}>
      <NotificationBar />
      <Toolbar className={classes.appToolbar}>
          <AppLogo />
          <Box className={classes.grow} />
          <Box className={classes.sectionDesktop}>
            {/* <LocationDisplay /> */}
            <HistoryMessages />
            <HeaderMessages />
          </Box>
          <Box className={classes.sectionMobile}>    {/* This is mobile header */}
            <Badge
                className={classes.badgeStyle}
                color='secondary'>
              <HistoryMessages />              
            </Badge>
            <IconButton
              className={clsx(classes.notiBtn, 'notiBtn')}
              aria-label='show cart'
              aria-controls={mobileMenuId}
              aria-haspopup='true'
              onClick={handleMobileMenuOpen}
              color='inherit'>
              {/* <MoreIcon /> */}
              <Badge
                className={classes.badgeStyle}
                badgeContent={getCartCount()}
                color='secondary'>
                <LocalGroceryStoreIcon className={clsx(classes.materialUiIcon, 'LocalGroceryStoreIcon')} />
              </Badge>
              {/* <LocalGroceryStoreIcon/> */}
            </IconButton>
            {/* <IconButton
              className={clsx(classes.notiBtn, 'notiBtn')}
              color='inherit'
              onClick={handleMobileMenuOpen}>
                <HistoryIcon className={clsx(classes.materialUiIcon, 'HistoryIcon')} />
            </IconButton> */}
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
    </>
  );
};
export default AppHeader;
